
import state from './../../zviz2/zviz/state';
import {default as Group, Controller as GroupController} from './../../zviz2/zviz/components/group';
import {extend} from './../../zviz2/zviz/functions';

import {default as TopoJSONFeature} from './../../zviz2/vendor/topojson/src/feature';

import Country from './country';
import {mapdata} from './mapdata';
import {applyProjection, createPath, addToBoundingBox} from './functions';
import Vector2 from './../../zviz2/zviz/math/vector2';
//import {LifeCycle} from './../zviz2/zviz/cycle';

import flowModel from './../../model/flow';


class Controller extends GroupController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);
        
        // this.setResponder('map.height', [this, this.updateChildren]);

        this.maxHeight = 500;
        this.scale = 1;
        this.globalBounds = [{x:0, y:0}, {x:0, y:0}];
        this.regionalBBoxes = new Map();

        this.countryData = new Map();
        for(let id of Object.keys(mapdata.details)){
            let d = mapdata.details[id];
            if(d.bbox.length == 4){

                let b1 = applyProjection([d.bbox[2], d.bbox[1]]);
                let b2 = applyProjection([d.bbox[0], d.bbox[3]]);
                
                d.localBBox = [{x: b1[0], y:b1[1]}, {x: b2[0], y: b2[1]}];

            }else{
                d.localBBox = [{x: 0, y:0}, {x: 0, y: 0}];
            }
            if(d.centroid && d.centroid.length == 2){
                d.localCentroid = applyProjection([d.centroid[1], d.centroid[0]]);
            }else{
                d.localCentroid = [0.5*(d.localBBox[1].x + d.localBBox[0].x), 
                        0.5*(d.localBBox[1].y - d.localBBox[0].y)]; 
            }
            this.countryData.set(d.id3, d);

            if(d.region && d.region != ''){
                let rbox = [];
                if(this.regionalBBoxes.has(d.region)){
                    rbox = this.regionalBBoxes.get(d.region); 
                }else{
                    rbox = [{x:0, y:0}, {x:0, y:0}];
                }
                addToBoundingBox(rbox, d.localBBox);
                this.regionalBBoxes.set(d.region, rbox);
            }

            addToBoundingBox(this.globalBounds, d.localBBox);

        }
        
    }

    itemHover(){
        for(let child of this.children){
            child.update();
        }
    }

    render(renderer){
        
        this.getTransformation().setObjectScale(state.get('map.transformation.scale') || 1);
        let position = state.get('map.transformation.position') || {x:0, y:0};
        this.getTransformation().setPosition(position.x, position.y);
        super.render(renderer);
    }

    zoomTo(boundingBox){

        if(boundingBox[0].x == 0 && boundingBox[1].x == 0){
            boundingBox = this.globalBounds;
        }
        
        let svg = this.getControllerByUid('svg');

        let wScale = svg.width / (boundingBox[1].x - boundingBox[0].x);
        let hScale = this.maxHeight / (boundingBox[1].y - boundingBox[0].y);

        let scale = Math.min(wScale, hScale);
        let width = scale * (boundingBox[1].x - boundingBox[0].x);
        let height = scale * (boundingBox[1].y - boundingBox[0].y)

        let position = {
            x: -1*scale*boundingBox[0].x + 0.5*(svg.width - scale * (boundingBox[1].x - boundingBox[0].x)),
            y: -1*scale*boundingBox[0].y
        }

        svg.setHeight(height);
        svg.setBoundingBox(boundingBox);

        // this.getTransformation().setObjectScale(scale);        
        // this.getTransformation().setPosition(position.x, position.y);

        state.set('map.transformation', {scale: scale, position: position});

    
    }

    mapValue(dimension, value){
        if(dimension == 'region'){
            value = this.models['flow'].mapRegionValue(value);
        }else if(dimension == 'country'){
            value = this.models['flow'].mapCountryValue(value);
        }
        return value;
    }

    getGeoData(value, dimension){

        value = this.mapValue(dimension, value);

        let bbox = [new Vector2(), new Vector2()];
        let ids = [];
        let centroid = new Vector2();
        for(let [k, country] of this.countryData){
            if((dimension == 'region' && country.region == value) ||
                    (dimension == 'country' &&  country.country == value)){
                if(! (country.localBBox[0].x == 0 && country.localBBox[1].x && 
                        country.localBBox[0].y == 0 && country.localBBox[1].y == 0)){

                    bbox = addToBoundingBox(bbox, country.localBBox);
                    
                }
                
                ids.push(country.id3);

                centroid.x = country.localCentroid[0];
                centroid.y = country.localCentroid[1];
            }
        }
        if(ids.length == 0){
            return null;
        }


        let scale = this.getTransformation().objectScaleFact.x; 
        let pos = this.getTransformation().position;

        bbox[0].multiply(scale).add(pos);
        bbox[1].multiply(scale).add(pos);
        if(ids.length > 1){
            centroid.x = 0.5*(bbox[1].x + bbox[0].x);
            centroid.y = 0.5*(bbox[1].y + bbox[0].y);

        }else{
            centroid.multiply(scale).add(pos);
        }

        return {
            ids: ids,
            bbox: bbox,
            centroid: centroid,
        };
    }

    

    isInData(d){
        this.models['flow'].getDimensions();
        if(! d[this.models['flow'].dimensionRegion]){
            return false;
        }
        if(! this.models['flow'].items[this.models['flow'].dimensionRegion]){
            return false;
        }
        let items = this.models['flow'].items[this.models['flow'].dimensionRegion];
        if(items){
            for(let key of Object.keys(items)){
                if(items[key].value == d[this.models['flow'].dimensionRegion] ||
                        d.id2 === this.models['flow'].countryMap[items[key].value]){
                    return true;
                }
            }
        }
        return false;

    }

    getChildren(){

        let countries = TopoJSONFeature(mapdata.topojson, 
                mapdata.topojson.objects.countries);
    
        let globalBounds = [ {x:0, y: 0}, {x:0, y: 0} ];
        let result = [];

        for(let i = 0; i < countries.features.length; i++){
            let c = countries.features[i];
            if(c.id == 'ATA'){  // do not render antarctica
                continue;
            }

            if(this.countryData.has(c.id)){
                let d = this.countryData.get(c.id);
                 if(this.isInData(d)){
                    globalBounds = addToBoundingBox(globalBounds, d.localBBox);
                 }
            }

            let path = createPath(c.geometry.coordinates);           
        
            result.push(extend({
                uid: '_c'+c.id,
                properties: {
                    data: { id: c.id },
                },
                private: {
                    path: path
                }
            }, Country));    

        }


        let v = state.get('filter.region');
        let c = state.get('filter.country');

        if( c ){
            
            if( globalBounds[0].x == 0 && globalBounds[1].x == 0 && v){
                // country has no bounding box, stay in the region instead
                v = this.models['flow'].mapRegionValue(v);
                if( this.regionalBBoxes.has(v)){
                    this.zoomTo(this.regionalBBoxes.get(v));
                }else{
                    this.zoomTo(this.globalBounds);
                }
            }else{
                // zoom to country
                const mY = 0.25 * (globalBounds[1].y - globalBounds[0].y);
                const mX = 0.25 * (globalBounds[1].x - globalBounds[0].x);
                this.zoomTo([
                    {x: globalBounds[0].x - mX, y: globalBounds[0].y - mY},
                    {x: globalBounds[1].x + mX, y: globalBounds[1].y + mY}
                ]);
            }
        }else if( v ){
            v = this.models['flow'].mapRegionValue(v);
            if( this.regionalBBoxes.has(v)){
                this.zoomTo(this.regionalBBoxes.get(v));
            }else{
                this.zoomTo(globalBounds);
            }
        }else{
            this.zoomTo(this.globalBounds);
        }


        return result;

    }


} 


let Blueprint = extend({
    type: Controller,
    models: {
        'flow': null,
        // 'geo': null
    },
    listeners: [
        (ctrl) => ( ctrl.addListener(ctrl.models['flow'], [ctrl, ctrl.update]) ),
        // (ctrl) => ( ctrl.addListener(ctrl.models['geo']) ),
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.update], 'filter') ),
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.itemHover], 'map.itemHover') ),
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.update], 'map.transformation') )
    ],
    properties: {
        attributes: {
            'class': 'countries'
        }
    },
    children: [
       (ctrl) => ( ctrl.getChildren() )
    ]
}, Group);


export default Blueprint;
export {Controller, Blueprint};

